/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import * as stylex from '@stylexjs/stylex';
import { createContext, type ForwardedRef, forwardRef } from 'react';
import {
  type ContextValue,
  Dialog as DialogCore,
  type DialogProps as DialogPropsCore,
  Modal as ModalCore,
  type ModalOverlayProps,
  useContextProps,
} from 'react-aria-components';
import { breakpoints, zIndices } from '../../constants.stylex';
import { $ } from '../../tokens.stylex';

interface DialogProps
  extends Omit<DialogPropsCore, 'style' | 'className'>,
    Pick<
      ModalOverlayProps,
      'defaultOpen' | 'isKeyboardDismissDisabled' | 'isOpen' | 'shouldCloseOnInteractOutside' | 'isDismissable' | 'onOpenChange'
    > {
  style?: stylex.StyleXStyles;
}

const DialogContext = createContext<ContextValue<DialogProps, HTMLDivElement>>({});

const Dialog = forwardRef((props: DialogProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, DialogContext);

  const {
    style,
    children,
    defaultOpen,
    isKeyboardDismissDisabled,
    isOpen,
    shouldCloseOnInteractOutside,
    isDismissable,
    onOpenChange,
    ...coreProps
  } = props;

  return (
    <ModalCore
      defaultOpen={defaultOpen}
      isKeyboardDismissDisabled={isKeyboardDismissDisabled}
      isOpen={isOpen}
      shouldCloseOnInteractOutside={shouldCloseOnInteractOutside}
      isDismissable={isDismissable}
      onOpenChange={onOpenChange}
      {...stylex.props(modalStyles.base)}
    >
      {(renderProps) => (
        <DialogCore
          ref={ref}
          {...stylex.props(styles.base, (renderProps.isExiting || renderProps.isEntering) && styles.transitioning, style)}
          {...coreProps}
          {...renderProps}
        >
          {children}
        </DialogCore>
      )}
    </ModalCore>
  );
});

const styles = stylex.create({
  base: {
    padding: 20,
    borderRadius: 16,
    outline: 'none',
    overflow: 'hidden',
    backgroundColor: $.surface00,
    boxShadow: $.shadowCenter060Medium,
    display: 'flex',
    flexDirection: 'column',
    margin: {
      default: 0,
      [breakpoints.small]: 8,
    },
    width: {
      default: null,
      [breakpoints.small]: '100%',
    },
    opacity: {
      default: 1,
      ':is([data-entering], [data-exiting])': 0,
    },
    position: 'relative',
    transitionDuration: '200ms',
    transitionProperty: 'opacity, transform',
    transitionTimingFunction: 'ease-in-out',
    height: 'fit-content',
    maxHeight: '80%',
    paddingTop: {
      default: 20,
      [breakpoints.small]: 28,
    },
  },
  transitioning: {
    opacity: 0,
    transform: 'translateY(-25px)',
  },
});

const modalStyles = stylex.create({
  base: {
    alignItems: 'center',
    backgroundColor: $.opacity48,
    display: 'flex',
    justifyContent: 'center',
    opacity: {
      default: 1,
      ':is([data-entering], [data-exiting])': 0,
    },
    position: 'fixed',
    transitionDuration: '200ms',
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease',
    zIndex: zIndices.modal,
    height: 'var(--visual-viewport-height)',
    left: 0,
    top: 0,
    width: '100vw',
  },
});

const DIALOG_SLOTS = {
  TITLE: 'title',
  TOP_BAR: 'top-bar',
  BOTTOM_BAR: 'bottom-bar',
  CLOSE: 'close',
};

export { Dialog, DIALOG_SLOTS, DialogContext, type DialogProps };
